import { render, staticRenderFns } from "./MemberChooseGroupsView.vue?vue&type=template&id=67ba2498"
import script from "./MemberChooseGroupsView.vue?vue&type=script&lang=ts"
export * from "./MemberChooseGroupsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports